import React, { useContext } from "react";
import { StoreContext } from "../../context/StoreContext";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useMatchMedia } from "../../util/useMatchMedia";
import { Box } from "@mui/material";
import frameBg from "../../assets/Frame.png";

const Banner = () => {
  const isMobile = useMatchMedia("(max-width: 576px)", true);
  const { data } = useContext(StoreContext);
  const storeDetails = data.store_master;

  return (
    <>
      <Box className="banner-container" sx={{lineHeight:'0px'}}>
        <img src={frameBg} alt="image" className="banner-image" />
      </Box>
    </>
  );
};

export default Banner;
